import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";

export default function DeletionModal({
  open,
  setOpen,
  deleteFunction,
  safeDelete = true,
  itemClass = "Item",
  name,
  id,
}) {
  const { t } = useTranslation();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    borderRadius: 5,
    boxShadow: 24,
    pb: 4,
    pt: 1,
  };

  const [enteredValue, setEnteredValue] = React.useState("");

  return (
    <div>
      <Modal
        open={open}
        //onClose={handleClose}
        disableAutoFocus={true}
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              color="secondary"
              aria-label="add an alarm"
              sx={{ mr: 1 }}
              onClick={() => {
                setEnteredValue("");
                setOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              mx: 3,
            }}
          >
            <Typography sx={{ fontSize: 16, textDecoration: "underline" }}>
              {t("deletionConfirm")} {itemClass} "{name}":
            </Typography>
            <Divider flexItem sx={{ my: 3 }} />
            {safeDelete && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography sx={{ fontStyle: "italic" }}>
                  {t("enterDelete")}:
                </Typography>
                <TextField
                  autoFocus
                  size="small"
                  value={enteredValue}
                  onChange={(e) => setEnteredValue(e.target.value)}
                  placeholder={t("delete")}
                  sx={{
                    width: 100,
                    ml: 2,
                    "& input::placeholder": {
                      fontStyle: "italic",
                    },
                  }}
                />
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                disabled={safeDelete && enteredValue !== t("delete")}
                endIcon={<DeleteForeverIcon />}
                onClick={() => {
                  setEnteredValue("");
                  deleteFunction(id);
                  setOpen(false);
                }}
              >
                {t("Delete")} {itemClass}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
